import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";

const cols = [
  { title: "Produit", items: [["Studio IA", "/register"], ["Hub de diffusion", "/register"], ["Analytiques", "/register"], ["Tarifs", "/pricing"]] },
  { title: "Réseaux", items: [["Meta Ads", "/register"], ["TikTok Ads", "/register"], ["Google Ads", "/register"], ["Pinterest & Snap", "/register"]] },
  { title: "Entreprise", items: [["Contact", "/contact"], ["SAV & Support", "/support"], ["Mentions légales", "/mentions-legales"], ["Politique de confidentialité", "/politique-confidentialite"]] },
];

export const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="border-t border-border mt-24">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <Logo onClick={() => navigate("/")} />
          <p className="mt-4 text-sm text-muted-foreground max-w-xs leading-relaxed">
            La plateforme IA pour créer, optimiser et diffuser vos publicités e-commerce sur tous les réseaux en un clic.
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="font-display font-semibold text-sm mb-3">{c.title}</h4>
            <ul className="space-y-2">
              {c.items.map(([label, to]) => (
                <li key={label}>
                  <button onClick={() => navigate(to)} className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid={`footer-${label.toLowerCase().replace(/[^a-z]/g, "-")}`}>{label}</button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-muted-foreground">
          <span>© 2026 Monaga Adflow — MONASAR. Tous droits réservés.</span>
          <div className="flex items-center gap-4">
            <button onClick={() => navigate("/politique-confidentialite")} className="hover:text-foreground transition-colors" data-testid="footer-privacy-link">Politique de confidentialité</button>
            <button onClick={() => navigate("/mentions-legales")} className="hover:text-foreground transition-colors" data-testid="footer-legal-link">Mentions légales</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
